export const isFirefox = (ua: string) => !!ua.match(/firefox|fxios/i)?.length;
